export default "__VITE_ASSET__CRL19BTS__"